// extracted by mini-css-extract-plugin
module.exports = {"box":"city-style_box__3bhW8","city_li":"city-style_city_li__6UGkR","city_info":"city-style_city_info__2_H2x"};